import React, { useState, useRef, useEffect } from "react";
import {
  CarDetailsWrapper,
  Header,
  CarType,
  HoleSpeedWrapper,
  Players,
  SoftwareUpdate,
  FleetCarLegend,
  ItemWrapper,
  DropDownContainer
} from "commonComponents/CarDetails/CarDetailsStyled";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";

import { isActionZoneAlert } from "_helperFunctions/isActionZoneAlert";
import { mapHelpers } from "pages/Pins/utils/mapHelpers";
import {
  deviceType,
  getFeatureSetOption,
  getFeaturesList,
  isUserAdmin,
  isUserBasic,
  isUserReadOnly,
  isUserSupport,
  carType as constCartype,
  speakerVolume,
  holesConst,
  distances
} from "../../constant";
import SmallCarIcon from "assets/icons/small-car.png";
import NotCommunicating from "assets/svgIcons/NotCommunicating";
import OutOfServiceIcon from "assets/svgIcons/CarType/OutOfService";
import FbIcon from "assets/svgIcons/CarType/F&B";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";
import BatteryLowIcon from "assets/svgIcons/BatteryIcon";
import BatteryWithPowerIcon from "assets/svgIcons/BatteryWithPowerIcon";
import ResendIcon from "assets/svgIcons/ResendIcon";
import PaceIcon from "assets/svgIcons/MapLegendPopup/PaceAlert/PaceIcon";
import OnChargeIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/OnCharge";
import UnKnowIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/UnKnownIcon";
import NotGuardianCapableIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/NotGuardianCapable";
import DistanceHiddenIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/DistanceHiddenIcon";
import DistanceShowIcon from "assets/svgIcons/MapLegendPopup/CarLocation/Location";
import {
  COMMON_COMPONENTS_STATES,
  CAR_NUMBER_MESSAGE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import moment from "moment";
import CarNotCommunicatingImage from "assets/svgIcons/CarType/NotCommunication";
import TimeIcon from "assets/svgIcons/TimeIcon";
import MarshalsCarIcon from "assets/svgIcons/CarType/Marshals";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import CloseIcon from "assets/icons/cross-icon.png";
import DetailAccordions from "./AccordionDetails/index";
import DownloadIcon from "assets/svgIcons/DownloadIcon";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import ChatIcon from "assets/svgIcons/ChatIcon";
import SignalIcon from "assets/svgIcons/SignalIcon";
import MobileSignalIcon from "assets/svgIcons/MobileSignalIcon";
import LocationPointIcon from "assets/svgIcons/LocationPointIcon";
import IconDetailIcon from "assets/svgIcons/IconDetailIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseOutIcon from "assets/svgIcons/ModalCloseOutIcon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppBar from "@mui/material/AppBar";
import LockIcon from "assets/svgIcons/LockIcon";
import UnLockIcon from "assets/svgIcons/UnlockIcon";
import PlayerIcon from "assets/svgIcons/PlayerIcon";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import KeyIcon from "assets/svgIcons/KeyIcon";
import { SelectContainer } from "commonComponents/FormElement/Select/SelectStyled";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FlagIcon from "assets/svgIcons/FlagIcon";
import {
  MESSAGE_FLEET_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  UPDATED_CAR_DATA_STATE
} from "globalStore/globalStore";
import {
  Container,
  TabWrapper,
} from "commonComponents/CarDetails/DetailsTabs/DetailsTabStyled";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { Tooltip } from "@mui/material";
import { isCarInUse } from "_helperFunctions/isCarInUse";
import { useTranslation } from "react-i18next";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import RenderBatteryIcon from "pages/Fleet/Cars/ListView/CarInfoCard/renderBatteryIcon";
import { connectionType } from "../../_helperFunctions/connectionType";
import XMLParser from 'react-xml-parser';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const CarDetails = React.memo(({ carInformation, setIsShownCarDetail, closeWindowState, handleMapCarDetailClick, handleClick }) => {
  const MaxWiFiIntervalInMinutes = 6;
  const MaxRTResponseTimeInMinutes = 45;
  const MaxRTResponseTimeInMinutesFT = 360;
  const {
    isEnabled,
    isSiteUsingYards,
    convertMileToKM,
    canEnable,
    canStage,
    isStaged,
  } = useCarSettingsData();
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

  const { t } = useTranslation();

  const dispatch = useDispatch();


  const [openLegend, setOpenLegend] = React.useState(false);
  const [showLoadingField, setShowLoadingField] = useState(null);
  const [openSoftwareUpdate, setOpenSoftwareUpdate] = React.useState(false);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [show, setShow] = useState(false);
  const [domRender, setDomRender] = useState(false);
  const [carTypeActiveButton, setCarTypeActiveButton] = useState(false);
  const [speedDataActiveButton, setSpeedDataActiveButton] = useState(false);
  const [stageCarActiveButton, setStageCarActiveButton] = useState(false);
  const [enableCarActiveButton, setEnableCarActiveButton] = useState(false);
  const [EnabledCarsState, setEnabledCarsState] = useState(false);

  const inputelm = useRef(null);
  const {
    siteSettingsData,
    carProductData,
    stagingModeData,
    getCarPathActionZone,
    updateCarStatus,
    getUserRole,
    getSiteSettingStateAction
  } = useSelector((state) => state.commonReducers) || [];

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const timeZoneOffset = siteSettingsData && siteSettingsData?.TimeZoneOffset;

  const [ATMversion, setATMversion] = useState(carInformation?.Car?.ATMversion);
  const ActionZoneId = carInformation?.Car?.ActionZoneId;
  const AndroidGolfGeniusVersion = carInformation?.Car?.AndroidGolfGeniusVersion;
  const AndroidOSVersion = carInformation?.Car?.AndroidOSVersion;
  const CarControlType = carInformation?.Car?.CarControlType;
  const ChargeControlMode = carInformation?.Car?.ChargeControlMode;
  const Connection = carInformation?.Car?.Connection;
  const DevType = carInformation?.Car?.DevType;
  const DistancesEnabledCar = carInformation?.Car?.DistancesEnabledCar;
  const FSversion = carInformation?.Car?.FSversion;
  const Faults = carInformation?.Car?.Faults;
  const GPSOdometerBase = carInformation?.Car?.GPSOdometerBase;
  const GPSOdometerBaseVersion = carInformation?.Car?.GPSOdometerBaseVersion;
  const GuardianCapable = carInformation?.Car?.GuardianCapable;
  const GuardianMode = carInformation?.Car?.GuardianMode;
  const HasMoved = carInformation?.Car?.HasMoved;
  const HoleLocation = carInformation?.Car?.HoleLocation;
  const IMEI = carInformation?.Car?.IMEI;
  const IsCharging = carInformation?.Car?.IsCharging;
  const LastCarUpdateInUtc = carInformation?.Car?.LastCarUpdateInUtc;
  const LastRTInUtc = carInformation?.Car?.LastRTInUtc;
  const Latitude = carInformation?.Car?.Latitude;
  const LocationGprsSignalStrength = carInformation?.Car?.LocationGprsSignalStrength;
  const LocationReasonForReport = carInformation?.Car?.LocationReasonForReport;
  const LocationSequenceNumber = carInformation?.Car?.LocationSequenceNumber;
  const Longitude = carInformation?.Car?.Longitude;
  const MDN = carInformation?.Car?.MDN;
  const MFW = carInformation?.Car?.MFW;
  const MaxHolesAllowedCar = carInformation?.Car?.MaxHolesAllowedCar;
  const MaxHolesAllowedFleet = carInformation?.Car?.MaxHolesAllowedFleet;
  const MaxHolesExceeded = carInformation?.Car?.MaxHolesExceeded;
  const MaxHolesExceededAlert = carInformation?.Car?.MaxHolesExceededAlert;
  const MaxHolesExceededDistancesDisabled = carInformation?.Car?.MaxHolesExceededDistancesDisabled;
  const OSversion = carInformation?.Car?.OSversion;
  const PaceStatus = carInformation?.Car?.PaceStatus;
  const PackageManifestId = carInformation?.Car?.PackageManifestId;
  const PrimaryNetwork = carInformation?.Car?.PrimaryNetwork;
  const SOSAlertEnabled = carInformation?.Car?.SOSAlertEnabled;
  const SWversion = carInformation?.Car?.SWversion;
  const SecondaryCarType = carInformation?.Car?.SecondaryCarType;
  const SimCardNumber = carInformation?.Car?.SimCardNumber;
  const SiteId = carInformation?.Car?.SiteId;
  const SpeakerSelectionCar = carInformation?.Car?.SpeakerSelectionCar;
  const TournId = carInformation?.Car?.TournId;
  const VehNotes = carInformation?.Car?.VehNotes;
  const VirtualHourmeterBase = carInformation?.Car?.VirtualHourmeterBase;
  const VirtualHourmeterBaseVersion = carInformation?.Car?.VirtualHourmeterBaseVersion;
  const sharkExperience = carInformation?.Car?.sharkExperience;
  const v2App = carInformation?.Car?.v2App;
  const v2Launcher = carInformation?.Car?.v2Launcher;
  const v2Ui = carInformation?.Car?.v2Ui;
  const speed = carInformation?.Car?.MaxSpeed;
  const lastWifiInUTC = carInformation?.Car?.LastWiFiInUtc;
  const carType = carInformation?.Car?.CarType;
  const carnumber = carInformation?.Car?.CarNumber;
  const carid = carInformation?.Car?.GpsiCarId;
  const BatteryLevel = carInformation?.Car?.BatteryLevel;
  const Course = carInformation?.Car?.Course;
  const HolesPlayed = carInformation?.Car?.HolesPlayed;
  const Hole = carInformation?.Car?.Hole;
  const pace = carInformation?.Car?.Pace;
  const DistanceUnits = carInformation?.Car?.DistanceUnits;
  const LastLocationUpdateInUtc = carInformation?.Car?.LastLocationUpdateInUtc;
  const [holes, setHoles] = useState(MaxHolesAllowedCar);
  const EnableMaxHole = !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role));

  const [speedData, setSpeedData] = React.useState(carInformation?.Car?.MaxSpeed);
  const [allowedToMove, setAllowedToMove] = React.useState(carInformation?.Car?.AllowedToMove);
  const [speakerSetting, setSpeakerSetting] = React.useState(SpeakerSelectionCar);
  const [distancesEnabled, setDistancesEnabled] = React.useState(DistancesEnabledCar);

  const actionZoneAlert = isActionZoneAlert(getCarPathActionZone, ActionZoneId);

  const UpdatesPending = carInformation?.Car?.UpdatesPending;

  const isInitialized = useRef(false);
  const memberEnabled = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ));
  const isMemberCar = memberEnabled && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role));

  const defaultCartypes = [constCartype.bevcart, constCartype.member, constCartype.outOfService, constCartype.normal, constCartype.memberSpecial];
  const [persistCarType, setPersistCarType] = useState(defaultCartypes.includes(carType));
  const [carTypeVal, setCarTypeVal] = useState(SecondaryCarType === constCartype.handicap ? constCartype.memberSpecial : carType);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingManifestServices(siteId.get()));
  }, []);

  useEffect(() => {
    if (!isInitialized.current && carInformation) {
      playerNameData1.set(carInformation?.Car?.PlayerName1 == null ? "" : carInformation?.Car?.PlayerName1);
      playerNameData2.set(carInformation?.Car?.PlayerName2 == null ? "" : carInformation?.Car?.PlayerName2);

      isInitialized.current = true;
    }
  }, [carInformation]);

  const [actionZoneText, setActionZoneText] = React.useState(null);

  useEffect(() => {
    getCarPathActionZone?.map((item) => {
      if (item.Id === ActionZoneId) {
        var actionZoneText = item.Label;
        setActionZoneText(actionZoneText);
      }
    });
  }, [getCarPathActionZone]);

  useEffect(() => {
    const xml = new XMLParser().parseFromString(getSiteSettingStateAction);
    const defaultCarType = xml && xml.getElementsByTagName('Car').filter((car) => {
      return car.value == carnumber;
    });
    defaultCarType && defaultCarType.length > 0 && setPersistCarType(true);
  }, [getSiteSettingStateAction])
  useEffect(() => {
    if (updateCarStatus === "success") {
      dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId));
      dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
    }
  }, [updateCarStatus]);

  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const {
    setMsgToSingleCar,
    playerNameData1,
    playerNameData2,
    setStagedCarsState,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);

  const {
    taggedCarsSaverGlobalState,
    taggedCarsDisplayerGlobalState,
    showTaggedCarArray,
    showMessageBoxForSingleCar,
    showCarDetails
  } = useHookstate(MAP_GLOBAL_STATES);

  const navigate = useNavigate();

  useEffect(() => {
    if (Object.keys(carProductData).length > 0) {
      if (canStage(carInformation?.Car) && !stageCarActiveButton) {
        setStagedCarsState.set(isStaged(carInformation?.Car, carProductData));
      } else if (canEnable(carInformation?.Car) && !enableCarActiveButton) {
        setEnabledCarsState(isEnabled(carInformation?.Car, carProductData));
      }
    }
  }, [carProductData]);

  useEffect(() => {
    editableComponent(t("Speaker_Setting"));
  }, [speakerSetting]);

  useEffect(() => {
    editableComponent(t("Show/Hide_Distances"));
  }, [distancesEnabled]);

  useEffect(() => {
    editableComponent(t("Max_Number_of_Holes"));
  }, [holes]);

  const {
    setCarNumber,
    carsForMessagesGetter,
    carsGpsSelectorData,
  } = useHookstate(CAR_NUMBER_MESSAGE);

  const closeModal = (e) => {
    setCarTypeVal(SecondaryCarType === constCartype.handicap ? constCartype.memberSpecial : carType);
    setCarTypeActiveButton(false);
    setSpeedDataActiveButton(false);
    setSpeedData(speed);
    e.preventDefault();
    setShow(true);
    setTabIndex(0);
  };

  const handleSpeedChange = (e) => {
    const { value } = e.target;
    setSpeedDataActiveButton(true);
    setSpeedData(value === "Default" ? -1 : value);
  };

  const { showTagCarsState, findCars } = useHookstate(COMMON_COMPONENTS_STATES);

  const fleetPageRedirect = (tagCarNumber) => {
    showTagCarsState.set(false);
    findCars.set(true);
    subNavDataState.set("MAP");
    sideDrawerActiveTabState.set(1);
    const exist = taggedCarsSaverGlobalState
      .get()
      .find((item) => item === tagCarNumber);
    const exist2 = showTaggedCarArray
      .get()
      .find((item) => item === tagCarNumber);
    if (!exist) {
      taggedCarsSaverGlobalState.set((tasks) => [...tasks, tagCarNumber]);
    }
    if (!exist2) {
      showTaggedCarArray.set((tasks) => [...tasks, tagCarNumber]);
    }
    taggedCarsDisplayerGlobalState.set(true);

    localStorage.setItem(
      "taggedCarsData",
      JSON.stringify({
        findCars: findCars.get(),
        taggedCarsDisplayerGlobalState: taggedCarsDisplayerGlobalState.get(),
        tagCarsDataMap: taggedCarsSaverGlobalState.get(),
        tagCarsDataFilters: showTaggedCarArray.get(),
      })
    );

    navigate("/map");

    handleCloseButton();
    let getTaggedCar = JSON.parse(localStorage.getItem("isTaggedCar"));

    if (getTaggedCar) {
      let tempToggle =
        getTaggedCar.state == true
          ? { state: false, carNumber: tagCarNumber }
          : { state: true, carNumber: tagCarNumber };
      localStorage.setItem("isTaggedCar", JSON.stringify(tempToggle));
    } else {
      let tempToggle = { state: true, carNumber: tagCarNumber };
      localStorage.setItem("isTaggedCar", JSON.stringify(tempToggle));
    }
  };

  function handleCloseButton() {
    playerNameData1.set("");
    playerNameData2.set("");

    if (closeWindowState) {
      handleMapCarDetailClick();
    } else {
      handleClick(true);
    }
  }
  const [isOff, setIsOff] = useState(true);

  const newDistancenew = () => {
    setIsOff(!isOff);

    const payload = {
      GpsiCarId: carInformation?.Car?.GpsiCarId,
      CarType: Number(carTypeVal === constCartype.memberSpecial ? constCartype.member : carTypeVal),
      MaxSpeed: speed.toString(),
      PlayerName1: playerNameData1.get(),
      PlayerName2: playerNameData2.get(),
      ATMversion: ATMversion,
      ActionZoneId: ActionZoneId,
      AllowedToMove: allowedToMove,
      AndroidGolfGeniusVersion: AndroidGolfGeniusVersion,
      AndroidOSVersion: AndroidOSVersion,
      BatteryLevel: BatteryLevel,
      CarControlType: CarControlType,
      CarNumber: carnumber,
      ChargeControlMode: ChargeControlMode,
      Connection: Connection,
      Course: Course,
      DevType: DevType,
      DistanceUnits: carInformation?.Car?.DistanceUnits === 1 ? 2 : 1,
      DistancesEnabledCar: DistancesEnabledCar,
      FSversion: FSversion,
      Faults: Faults,
      GPSOdometerBase: GPSOdometerBase,
      GPSOdometerBaseVersion: GPSOdometerBaseVersion,
      GuardianCapable: GuardianCapable,
      GuardianMode: GuardianMode,
      HasMoved: HasMoved,
      Hole: Hole,
      HoleLocation: HoleLocation,
      HolesPlayed: HolesPlayed,
      IMEI: IMEI,
      IsCharging: IsCharging,
      LastCarUpdateInUtc: LastCarUpdateInUtc,
      LastCarUpdateInUtc: LastCarUpdateInUtc,
      LastLocationUpdateInUtc: LastLocationUpdateInUtc,
      LastRTInUtc: LastRTInUtc,
      LastWiFiInUtc: lastWifiInUTC,
      Latitude: Latitude,
      LocationGprsSignalStrength: LocationGprsSignalStrength,
      LocationReasonForReport: LocationReasonForReport,
      LocationSequenceNumber: LocationSequenceNumber,
      Longitude: Longitude,
      MDN: MDN,
      MFW: MFW,
      MaxHolesAllowedCar: MaxHolesAllowedCar,
      MaxHolesAllowedFleet: MaxHolesAllowedFleet,
      MaxHolesExceeded: MaxHolesExceeded,
      MaxHolesExceededAlert: MaxHolesExceededAlert,
      MaxHolesExceededDistancesDisabled: MaxHolesExceededDistancesDisabled,
      OSversion: OSversion,
      Pace: pace,
      MaxSpeed: speed,
      PaceStatus: PaceStatus,
      PackageManifestId: PackageManifestId,
      PrimaryNetwork: PrimaryNetwork,
      SOSAlertEnabled: SOSAlertEnabled,
      SWversion: SWversion,
      SecondaryCarType: SecondaryCarType,
      SimCardNumber: SimCardNumber,
      SiteId: SiteId,
      SpeakerSelectionCar: SpeakerSelectionCar,
      TournId: TournId,
      UpdatesPending: UpdatesPending,
      VehNotes: VehNotes,
      VirtualHourmeterBase: VirtualHourmeterBase,
      VirtualHourmeterBaseVersion: VirtualHourmeterBaseVersion,
      sharkExperience: sharkExperience,
      v2App: v2App,
      v2Launcher: v2Launcher,
      v2Ui: v2Ui,
    };
    dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
      dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
      dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId));
    });
  };

  const handleTabsChange = (event, newValue) => {
    event.preventDefault();
    setTabIndex(newValue);
    if (newValue == 1) {
      setShow(false);
    } else {
      setShow(false);
    }
  };

  const update = carInformation?.Car?.UpdatesPending;

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }

  function paceString() {
    let result = "";

    if (carInformation) {
      if (pace > 0) result = pace.toString();
      else if (pace < 0) result = (-pace).toString();
      else result = " ";
      if (HolesPlayed > 0) result = result + (HolesPlayed > 1 ? "" : "");
    }

    return result;
  }

  const allCarsData =
    updatedCarData.get() && updatedCarData.get().length !== 0
      ? JSON.parse(updatedCarData.get())
      : [];

  const pacestring = paceString();
  const handleSpeakerVolumeChange = (e) => {
    setSpeakerSetting(e.target.value);
  }
  const deRegisterCar = () => {
    if (carProductData) {
      const GpsiCarId = carid;

      const payload = {
        GpsiCarId: GpsiCarId,
        AllowedToMove: allowedToMove,
        CarType: carTypeVal === constCartype.memberSpecial ? constCartype.member : carTypeVal,
        MaxSpeed: speedData.toString(),
        PlayerName1: carInformation.Car.PlayerName1,
        PlayerName2: carInformation.Car.PlayerName2,
        DistanceUnits: DistanceUnits,
        ATMversion: ATMversion,
        UnlockCode: stagingModeData?.UnlockCode,
        CarSerialNumber: stagingModeData?.CarSerialNumber,
        ControllerModel: stagingModeData?.ControllerModel,
        Odometer: carProductData?.Odometer, // no
        EnergyUnits: carProductData?.EnergyUnits, // no
        Deregister: true, // no
        GuardianCapable: GuardianCapable,
        MaxHolesAllowedCar: MaxHolesAllowedCar,
        DistancesEnabledCar: DistancesEnabledCar,
        G2UnlockCode: carProductData?.G2UnlockCode,
        SWversion: SWversion,
        OSversion: OSversion,
        FSversion: FSversion,
        WattHours: carProductData?.WattHours, // no
        FusionVersions: carProductData?.FusionVersions, // no
        SpeakerSelectionCar: SpeakerSelectionCar,
        SecondaryCarType: SecondaryCarType,
      };

      dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
        dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
        dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId));
        let temp = allCarsData;
        temp = temp.filter(
          (item1) => item1.Car.GpsiCarId !== carInformation?.Car?.GpsiCarId
        );

        updatedCarData.set(JSON.stringify(temp));
        showCarDetails.set(false);
        setIsShownCarDetail(false);
      });

      setDomRender(!domRender);
    }
  };

  const staggingChanges = () => {
    const payload = {
      ...carProductData,
      AllowedToMove: !setStagedCarsState.get(),
      ATMversion: ATMversion,
    };

    dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
      dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
      dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId)).then(
        () => {
          setStageCarActiveButton(false);
        }
      );
    });

    setDomRender(!domRender);
    setTabIndex(0);
  };

  const handleSaveCar = () => {
    const payload = {
      ...carProductData,
      AllowedToMove: EnabledCarsState,
      ATMversion: ATMversion,
    };

    dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
      dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
      dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId)).then(
        () => {
          setEnableCarActiveButton(false);
        }
      );
    });

    setDomRender(!domRender);
    setTabIndex(0);
  };

  const saveCarType = () => {
    setAllowedToMove(true);
    setCarTypeActiveButton(false);

    if (carProductData) {
      const payload = {
        GpsiCarId: carInformation?.Car?.GpsiCarId,
        AllowedToMove: allowedToMove,
        CarType: carTypeVal === constCartype.memberSpecial ? constCartype.member : carTypeVal,
        MaxSpeed: speedData.toString(),
        PlayerName1: carInformation.Car.PlayerName1,
        PlayerName2: carInformation.Car.PlayerName2,
        DistanceUnits: DistanceUnits,
        ATMversion: ATMversion,
        UnlockCode: stagingModeData?.UnlockCode,
        CarSerialNumber: stagingModeData?.CarSerialNumber,
        ControllerModel: stagingModeData?.ControllerModel,
        Odometer: carProductData?.Odometer, // no
        EnergyUnits: carProductData?.EnergyUnits, // no
        Deregister: carProductData?.Deregister, // no
        GuardianCapable: GuardianCapable,
        MaxHolesAllowedCar: MaxHolesAllowedCar,
        DistancesEnabledCar: DistancesEnabledCar,
        G2UnlockCode: carProductData?.G2UnlockCode,
        SWversion: SWversion,
        OSversion: OSversion,
        FSversion: FSversion,
        WattHours: carProductData?.WattHours, // no
        FusionVersions: carProductData?.FusionVersions, // no
        SpeakerSelectionCar: SpeakerSelectionCar,
        SecondaryCarType: carTypeVal === constCartype.memberSpecial ? constCartype.handicap : 0,
      };

      dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
        if (carTypeVal === constCartype.marshal || carTypeVal === constCartype.handicap) {
          persistCarType && dispatch(COMMON_SERVICES.postSavePersistentCarTypeSettingService(siteId.get(), carnumber, carTypeVal, persistCarType));
          !persistCarType && dispatch(COMMON_SERVICES.putRemovePersistentCarTypeSettingService(siteId.get(), carnumber, carTypeVal));
        }
        dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
        dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId));
      });

      setDomRender(!domRender);
    }

    setTabIndex(0);
  };

  const saveSpeedData = () => {
    setSpeedDataActiveButton(false);

    if (carProductData) {
      const payload = {
        GpsiCarId: carInformation?.Car?.GpsiCarId,
        AllowedToMove: allowedToMove,
        CarType: carTypeVal === constCartype.memberSpecial ? constCartype.member : carTypeVal,
        MaxSpeed: speedData.toString(),
        PlayerName1: carInformation.Car.PlayerName1,
        PlayerName2: carInformation.Car.PlayerName2,
        DistanceUnits: DistanceUnits,
        ATMversion: ATMversion,
        UnlockCode: stagingModeData?.UnlockCode,
        CarSerialNumber: stagingModeData?.CarSerialNumber,
        ControllerModel: stagingModeData?.ControllerModel,
        Odometer: carProductData?.Odometer, // no
        EnergyUnits: carProductData?.EnergyUnits, // no
        Deregister: carProductData?.Deregister, // no
        GuardianCapable: GuardianCapable,
        MaxHolesAllowedCar: MaxHolesAllowedCar,
        DistancesEnabledCar: DistancesEnabledCar,
        G2UnlockCode: carProductData?.G2UnlockCode,
        SWversion: SWversion,
        OSversion: OSversion,
        FSversion: FSversion,
        WattHours: carProductData?.WattHours, // no
        FusionVersions: carProductData?.FusionVersions, // no
        SpeakerSelectionCar: SpeakerSelectionCar,
        SecondaryCarType: SecondaryCarType,
      };
      dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
        dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
        dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId));
      });

      setDomRender(!domRender);
    }

    setTabIndex(0);
  };

  const holesChange = (e) => {
    setHoles(e.target.value);
  }
  const editableComponent = (field) => {
    const payload = {
      GpsiCarId: carInformation?.Car?.GpsiCarId,
      CarType: carTypeVal === constCartype.memberSpecial ? constCartype.member : carTypeVal,
      MaxSpeed: speed.toString(),
      PlayerName1: playerNameData1.get(),
      PlayerName2: playerNameData2.get(),
      ATMversion: ATMversion,
      ActionZoneId: ActionZoneId,
      AllowedToMove: allowedToMove,
      AndroidGolfGeniusVersion: AndroidGolfGeniusVersion,
      AndroidOSVersion: AndroidOSVersion,
      BatteryLevel: BatteryLevel,
      CarControlType: CarControlType,
      CarNumber: carnumber,
      ChargeControlMode: ChargeControlMode,
      Connection: Connection,
      Course: Course,
      DevType: DevType,
      DistanceUnits: DistanceUnits,
      DistancesEnabledCar: distancesEnabled,
      FSversion: FSversion,
      Faults: Faults,
      GPSOdometerBase: GPSOdometerBase,
      GPSOdometerBaseVersion: GPSOdometerBaseVersion,
      GpsiCarId: carid,
      GuardianCapable: GuardianCapable,
      GuardianMode: GuardianMode,
      HasMoved: HasMoved,
      Hole: Hole,
      HoleLocation: HoleLocation,
      HolesPlayed: HolesPlayed,
      IMEI: IMEI,
      IsCharging: IsCharging,
      LastCarUpdateInUtc: LastCarUpdateInUtc,
      LastCarUpdateInUtc: LastCarUpdateInUtc,
      LastLocationUpdateInUtc: LastLocationUpdateInUtc,
      LastRTInUtc: LastRTInUtc,
      LastWiFiInUtc: lastWifiInUTC,
      Latitude: Latitude,
      LocationGprsSignalStrength: LocationGprsSignalStrength,
      LocationReasonForReport: LocationReasonForReport,
      LocationSequenceNumber: LocationSequenceNumber,
      Longitude: Longitude,
      MDN: MDN,
      MFW: MFW,
      MaxHolesAllowedCar: holes,
      MaxHolesAllowedFleet: MaxHolesAllowedFleet,
      MaxHolesExceeded: MaxHolesExceeded,
      MaxHolesExceededAlert: MaxHolesExceededAlert,
      MaxHolesExceededDistancesDisabled: MaxHolesExceededDistancesDisabled,
      OSversion: OSversion,
      Pace: pace,
      MaxSpeed: speed,
      PaceStatus: PaceStatus,
      PackageManifestId: PackageManifestId,
      PrimaryNetwork: PrimaryNetwork,
      SOSAlertEnabled: SOSAlertEnabled,
      SWversion: SWversion,
      SecondaryCarType: SecondaryCarType,
      SimCardNumber: SimCardNumber,
      SiteId: SiteId,
      SpeakerSelectionCar: speakerSetting,
      TournId: TournId,
      UpdatesPending: UpdatesPending,
      VehNotes: VehNotes,
      VirtualHourmeterBase: VirtualHourmeterBase,
      VirtualHourmeterBaseVersion: VirtualHourmeterBaseVersion,
      sharkExperience: sharkExperience,
      v2App: v2App,
      v2Launcher: v2Launcher,
      v2Ui: v2Ui,
    };

    setShowLoadingField(field);

    dispatch(COMMON_SERVICES.updateCarType(payload)).then(() => {
      dispatch(COMMON_SERVICES.getCarServices(false, siteId.get())).then(() => {
        setShowLoadingField(null);
      });
      dispatch(COMMON_SERVICES.getProductData(carInformation?.Car?.GpsiCarId));
    });

    setDomRender(!domRender);
  };

  const iconData = {
    FleetCar: t("Fleet_car"),
    SpecialNeedCar: t("Special_needs_cars"),
    MarshalCar: t("Marshal_cars"),
    BeverageCar: t("Beverage_cars"),
    OutOfService: t("Out_of_service"),
    MemberCar: t("Member_car"),
    MemberSpecial: t("Member_/_Special_Needs")

  };

  function renderCarIcon() {
    switch (carTypeVal) {
      case constCartype.normal:
        return <img src={SmallCarIcon} alt="car" className="list-view" />;
      case constCartype.handicap:
        return <SpecialNeedsIcon />;
      case constCartype.marshal:
        return <MarshalsCarIcon />;
      case constCartype.bevcart:
        return <FbIcon />;
      case constCartype.member:
        return <MembercarIcon width={20} height={33} bg={"#00A000"} opacity={1} />;
      case constCartype.outOfService:
        return <OutOfServiceIcon />;
      case constCartype.memberSpecial:
        return <div style={{ display: "flex" }}><MembercarIcon width={20} height={33} bg={"#00A000"} opacity={1} /> <SpecialNeedsIcon width={15} height={25} /></div>;
      default:
        return "No icon";
    }
  }

  function isWifi() {
    let nowUtc = moment.utc();
    let lastWiFiUtc = moment.utc(lastWifiInUTC);
    lastWiFiUtc.add(MaxWiFiIntervalInMinutes, "minutes");
    return nowUtc.isBefore(lastWiFiUtc);
  }

  function issingle() {
    let responseTimeInMinutes =
      carInformation?.Car?.DevType === deviceType.FT
        ? MaxRTResponseTimeInMinutesFT
        : MaxRTResponseTimeInMinutes;
    if (carInformation?.Car?.LastRTInUtc === "0001-01-01T00:00:00") {
      return false;
    } else {
      let nowUtc = moment.utc();
      let lastRtUTC = moment.utc(carInformation?.Car?.LastRTInUtc);
      lastRtUTC.add(responseTimeInMinutes, "minutes");
      return nowUtc.isBefore(lastRtUTC);
    }
  }

  function lastUpdate() {
    var updated = moment
      .utc(LastLocationUpdateInUtc)
      .utcOffset(-timeZoneOffset); // convert to local time zone at course
    var now = moment(); // Note: moment apparently knows how to compare them even though zone applied to "updated"
    if (updated.isAfter(now)) updated = now;
    return updated.from(now);
  }

  function checkLastDate() {
    let updated = moment
      .utc(LastLocationUpdateInUtc)
      .utcOffset(-timeZoneOffset);
    let now = moment();
    if (updated.isAfter(now)) updated = now;
    return updated.format("ddd DD/MMM/YY hh:mm:ss a");
  }

  const minimumLongitude = -180.0;
  const maximumLongitude = 180.0;
  const minimumLatitude = -90.0;
  const maximumLatitude = 90.0;
  const Location = 0;

  function isValidLocation(latitude, longitude) {
    if (Math.abs(latitude) < Location && Math.abs(longitude) < Location)
      return false;
    if (!isValidLatitude(latitude)) return false;
    if (!isValidLongitude(longitude)) return false;
    return true;
  }

  if (!isValidLocation(Latitude, Longitude)) {
    return false;
  }

  function isValidLatitude(latitude) {
    return latitude >= minimumLatitude && latitude <= maximumLatitude;
  }

  function isValidLongitude(longitude) {
    return longitude >= minimumLongitude && longitude <= maximumLongitude;
  }

  function renderHoleNumber() {
    if (Course === 0) {
      return (
        <div style={{ backgroundColor: "#947550" }} className="flag-wrapper">
          <FlagIcon color="#000" />
          <span className="number-dig" style={{ color: "#000" }}>
            {Hole}
          </span>
        </div>
      );
    } else if (Course === 1) {
      return (
        <div
          style={{
            backgroundColor: mapHelpers.CourseBGColor(siteSettingsData, Course),
          }}
          className="flag-wrapper"
        >
          <FlagIcon
            color={
              siteSettingsData &&
                mapHelpers.lightOrDark(
                  mapHelpers.CourseBGColor(siteSettingsData, Course)
                ) === "light"
                ? "#000000"
                : "#ffffff"
            }
          />
          <span
            className="number-dig"
            style={{
              color:
                siteSettingsData &&
                  mapHelpers.lightOrDark(
                    mapHelpers.CourseBGColor(siteSettingsData, Course)
                  ) === "light"
                  ? "#000000"
                  : "#ffffff",
            }}
          >
            {Hole}
          </span>
        </div>
      );
    } else if (Course === 2) {
      return (
        <div
          style={{
            backgroundColor: mapHelpers.CourseBGColor(siteSettingsData, Course),
          }}
          className="flag-wrapper"
        >
          <FlagIcon
            color={
              siteSettingsData &&
                mapHelpers.lightOrDark(
                  mapHelpers.CourseBGColor(siteSettingsData, Course)
                ) === "light"
                ? "#000000"
                : "#ffffff"
            }
          />
          <span
            className="number-dig"
            style={{
              color:
                siteSettingsData &&
                  mapHelpers.lightOrDark(
                    mapHelpers.CourseBGColor(siteSettingsData, Course)
                  ) === "light"
                  ? "#000000"
                  : "#ffffff",
            }}
          >
            {Hole}
          </span>
        </div>
      );
    } else if (Course === 3) {
      return (
        <div
          style={{
            backgroundColor: mapHelpers.CourseBGColor(siteSettingsData, Course),
          }}
          className="flag-wrapper"
        >
          <FlagIcon
            color={
              siteSettingsData &&
                mapHelpers.lightOrDark(
                  mapHelpers.CourseBGColor(siteSettingsData, Course)
                ) === "light"
                ? "#000000"
                : "#ffffff"
            }
          />
          <span
            className="number-dig"
            style={{
              color:
                siteSettingsData &&
                  mapHelpers.lightOrDark(
                    mapHelpers.CourseBGColor(siteSettingsData, Course)
                  ) === "light"
                  ? "#000000"
                  : "#ffffff",
            }}
          >
            {Hole}
          </span>
        </div>
      );
    } else {
      return <span className="number-dig">not available</span>;
    }
  }

  const handleCarType = (e) => {
    setCarTypeActiveButton(true);
    setCarTypeVal(e.target.value);
    setPersistCarType(defaultCartypes.includes(e.target.value));
  };

  function pendingUpdate(abbrev) {
    let code = abbrev.substr(0, 2);
    let flag = abbrev.length > 2 ? abbrev.substr(2, 1) : "";
    let result = "";

    switch (code) {
      case "AD":
        result = "Action zone disabled list";
        break;
      case "AE":
        result = "Action zones";
        break;
      case "AF":
        result = "Auto flyovers";
        break;
      case "AM":
        result = "Car movement";
        break;
      case "AP":
        result = "APN config";
        break;
      case "AZ":
        result = "Action zones";
        break;
      case "BP":
        result = "Blindshots";
        break;
      case "CT":
        result = "Car type";
        break;
      case "DE":
        result = "Distances";
        break;
      case "DU":
        result = "Dist units";
        break;
      case "FB":
        result = "Food & bev";
        break;
      case "FD":
        result = "F&B items";
        break;
      case "FM":
        result = "F&B menu";
        break;
      case "MF":
        result = "Files (ads, etc)";
        break;
      case "MX":
        result = "Max speed";
        break;
      case "OS":
        result = "OS ver";
        break;
      case "P1":
        result = "Player 1 name";
        break;
      case "P2":
        result = "Player 2 name";
        break;
      case "PE":
        result = "Pace";
        break;
      case "PM":
        result = "Pwr mgmt";
        break;
      case "PP":
        result = "Pins";
        break;
      case "SC":
        result = "Scorecards";
        break;
      case "SH":
        result = "Show Players on Welcome Screen";
        break;
      case "SM":
        result = "Guardian mode";
        break;
      case "SP":
        result = "Score printing";
        break;
      case "SW":
        result = "SW ver";
        break;
      case "SY":
        result = "SW sys";
        break;
      case "TC":
        result = "Tourn config";
        break;
      case "TO":
        result = "Tournament";
        break;
      case "WA":
        result = "Weather alert";
        break;
      case "WT":
        result = "Welcome Text";
        break;
      default:
        result = abbrev;
    }

    if (flag !== "") {
      result += flag === "1" ? " enabled" : " disabled";
    }
    return result;
  }

  function updatesList() {
    if (UpdatesPending) {
      let result = "";
      let updates = UpdatesPending.split(",");
      for (let i = 0; i < updates.length; i++) {
        result += pendingUpdate(updates[i]);
        if (i < updates.length - 1) result += ", ";
      }

      return result;
    }
  }

  const handleSendMessage = () => {
    isLoading.set(true);

    const featureEnabled = !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().real_time_tracking);

    const userRole = getUserRole && getUserRole?.Role;
    const isPrivilegedUser = isUserAdmin(userRole) || isUserSupport(userRole);

    if ((featureEnabled || isPrivilegedUser) && isLoading.get()) {
      setCarNumber.set(carnumber);
    } else {
      setMsgToSingleCar.set(null);
    }

    if (isLoading.get()) {
      carsGpsSelectorData.set([carid]);
      carsForMessagesGetter.set([carnumber]);
    } else {
      carsForMessagesGetter.set(null);
      carsGpsSelectorData.set(null);
    }

    showMessageBoxForSingleCar.set(true);
  }

  const handleStageCar = (e) => {
    setStageCarActiveButton(true);
    setStagedCarsState.set(e.target.checked);
    setATMversion(ATMversion + 1);
  }

  const handleCancelChanges = () => {
    setStageCarActiveButton(false);
    setTabIndex(0);
  }

  const handleEnableCar = (e) => {
    setEnableCarActiveButton(true);
    setEnabledCarsState(e.target.checked);
    setATMversion(ATMversion + 1);
  }

  const legendStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "912px",
    width: "100%",
    border: "none",
    background: "transparent",
    padding: "9px",
    outline: "none",
  };

  const modalStyle = {
    width: 350,
    position: "absolute",
    top: "50%",
    right: "2%",
    background: "#fff",
    padding: "15px",
  };

  const crossButtonStyle = {
    position: "absolute",
    right: 10,
    top: 10,
    width: 12,
    height: 12,
    cursor: "pointer",
    whiteSpace: "nowrap",
  };

  return (
    <CarDetailsWrapper>
      <div className="close-icon-wrapper">
        <img
          style={{ cursor: "pointer" }}
          src={CloseIcon}
          className="close-icon"
          alt="close-icon"
          onClick={handleCloseButton}
        />
      </div>
      <Header>
        <div className="header-text">
          <div>
            <h4>
              {t("Car")} {carnumber}
            </h4>
          </div>
          <p>
            {t("Connect_ID")}# {carid}
          </p>
        </div>
        <div className="header-icons-wrapper">
          <Tooltip title={t("Send_Message")}>
            <span
              style={
                getFeatureSetOption(
                  siteSettingsData?.Features,
                  getFeaturesList().real_time_tracking
                ) && !(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))
                  ? {
                    backgroundColor: "#d3d3d3",
                    cursor: "no-drop",
                  }
                  : {}
              }
            >
              <ChatIcon
                onClick={handleSendMessage}
              />
            </span>
          </Tooltip>
          <Tooltip title={t("Find_car")}>
            <span>
              <LocationPointIcon
                color="#fff"
                onClick={() => fleetPageRedirect(carnumber)} // This is to redirect
              />
            </span>
          </Tooltip>
          <Tooltip title={t("Legend")}>
            <span>
              <IconDetailIcon
                onClick={() => setOpenLegend(true)}
                style={{ cursor: "pointer" }}
              />
              <Modal
                open={openLegend}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onClose={() => setOpenLegend(false)}
              >
                <Box sx={legendStyle}>
                  <FleetCarLegend className="fleet-car-legend">
                    <div className="modal-header">
                      <h2>Car Status</h2>
                      <button className="close-icon" onClick={() => setOpenLegend(false)}>
                        <CloseOutIcon />
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="first-section">
                        <ul className="alerts-icon-wrapper">
                          <li>{t("Alerts")}</li>
                          <li>
                            <span>35</span>
                            {t("Car_alert_detected")}
                          </li>
                          <li>
                            <span>35</span>
                            {t("Charge_alert_detected")}
                          </li>
                          <li>
                            <span>35</span>
                            {t("Alert_detected,_not_communicating")}
                          </li>
                          <li>
                            <span>35</span>
                            {t("Non-guardian_car")}
                          </li>
                          <li>
                            <span>35</span>
                            {t("Car_out_of_service")}
                          </li>
                        </ul>
                        <ul>
                          <li>{t("Connected_States")}</li>
                          <li>
                            <span>
                              <NotCommunicating color="#FF0000" />
                            </span>
                            {t("Not_communicating")}
                          </li>
                          <li>
                            <span>
                              <SignalIcon
                                width="13px"
                                height="12.21px"
                                color="#5AADFF"
                              />
                            </span>
                            {t("Connected_via_Wi-Fi")}
                          </li>
                          <li>
                            <span>
                              <SignalIcon width="13px" height="12.21px" />
                            </span>
                            {t("Not_connected_via_Wi-Fi")}
                          </li>
                          <li>
                            <span>
                              <MobileSignalIcon
                                width="13px"
                                height="12.21px"
                                color="#5AADFF"
                              />
                            </span>
                            {t("Cellular_connected_via_Network")}
                          </li>
                          <li>
                            <span>
                              <MobileSignalIcon width="13px" height="12.21px" />{" "}
                            </span>
                            {t("Cellular_not_connected_via_Network")}
                          </li>
                        </ul>
                        <ul>
                          <li>{t("Car_type")}</li>
                          <li>
                            <span>
                              <MarshalsCarIcon />
                            </span>
                            {t("Marshal_cars")}
                          </li>
                          <li>
                            <span>
                              <FbIcon />
                            </span>
                            {t("Food_&_beverage_cars")}
                          </li>
                          <li>
                            <span>
                              <SpecialNeedsIcon />
                            </span>
                            {t("Special_needs_car")}
                          </li>
                          <li>
                            <span>
                              <MembercarIcon width={15} height={15} bg={"#00A000"} opacity={1} />
                            </span>
                            {t("Member_car")}
                          </li>
                          <li style={{ gap: 1 }}>
                            <span><MembercarIcon width={15} height={15} bg={"#00A000"} opacity={1} /> <SpecialNeedsIcon width={15} height={15} /></span>
                            {t("Member_/_Special_Needs")}
                          </li>
                          <li>
                            <span>
                              <OutOfServiceIcon />
                            </span>
                            {t("Out_of_service")}
                          </li>
                        </ul>
                        <ul>
                          <li>{t("Pace_alerts")}</li>
                          <li style={{ gap: 6 }}>
                            <span>
                              <PaceIcon width={27} height={27} />
                            </span>
                            {t("Falling_behind_pace")}
                          </li>
                          <li style={{ gap: 6 }}>
                            <span>
                              <PaceIcon color="#FF0000" width={27} height={27} />
                            </span>
                            {t("Critically_behind_pace")}
                          </li>
                          <ul>
                            <li>{t("Speed_limit")}</li>
                            <li>
                              <span>7</span>
                              {t("Speed_limit_set")}
                            </li>
                          </ul>
                        </ul>
                        <ul>
                          <li>{t("Battery_status")}</li>
                          <li>
                            <span>
                              <BatteryLowIcon
                                width="15.07px"
                                height="8.14"
                                color="#00A692"
                              />
                            </span>
                            {t("Battery_ok")}
                          </li>
                          <li>
                            <span>
                              <BatteryLowIcon
                                width="15.07px"
                                height="8.14"
                                color="#FFE500"
                              />
                            </span>
                            {t("Battery_low")}
                          </li>
                          <li>
                            <span>
                              <BatteryLowIcon
                                width="15.07px"
                                height="8.14"
                                color="#FA3C30"
                              />
                            </span>
                            {t("Battery_critically_low")}
                          </li>
                          <li>
                            <span>
                              <OnChargeIcon width="15.07px" height="8.14" />
                            </span>
                            {t("On_charge")}
                          </li>
                        </ul>
                        <ul>
                          <li style={{ color: "transparent" }}>
                            {t("Battery_status")}
                          </li>
                          <li>
                            <span>
                              <BatteryWithPowerIcon
                                width="15.07px"
                                height="8.14"
                                color="#00A692"
                              />
                            </span>
                            {t("At_or_near_full_charge")}
                          </li>
                          <li>
                            <span>
                              <OnChargeIcon
                                width="15.07px"
                                height="8.14"
                                color="#FA3C30"
                              />
                            </span>
                            {t("Charging_inhibited")}
                          </li>
                          <li>
                            <span>
                              <UnKnowIcon />
                            </span>
                            {t("Unknown")}
                          </li>
                          <li>
                            <span>
                              <NotGuardianCapableIcon width={17} height={17} />
                            </span>
                            {t("Not_Guardian_capable")}
                          </li>
                        </ul>
                        <ul>
                          <li>{t("Distances")}</li>
                          <li style={{ gap: 12 }}>
                            <span>
                              <b>yds</b>
                            </span>
                            {t("Distances_in_yards")}
                          </li>
                          <li>
                            <span>
                              <b>m</b>
                            </span>
                            {t("Distances_in_meters")}
                          </li>
                          <li>
                            <span>
                              <DistanceHiddenIcon width={15} height={15} />
                            </span>
                            {t("Distances_hidden")}
                          </li>
                          <li>
                            <span>
                              <DistanceShowIcon color="green" width={18} height={18} />
                            </span>
                            {t("Distances_shown")}
                          </li>
                        </ul>
                        <ul>
                          <li>{t("Holes_Info")}</li>
                          <li>
                            <span className="number-icon">18</span>
                            {t("Hole_Location")}
                          </li>
                          <li>
                            <span className="number-icon red">18</span>
                            {t("Max_holes_overridden")}
                          </li>
                          <ul>
                            <li>{t("Car_Modes")}</li>
                            <li style={{ gap: 21 }}>
                              <span>
                                <LockIcon />
                              </span>
                              {t("Lockdown_mode_or_staged")}
                            </li>
                            <li>
                              <span>
                                <UnLockIcon />
                              </span>
                              {t("Normal_mode")}
                            </li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                    <div className="modal-header">
                      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <Link
                          href="https://help.visage.golf/visage-2/"
                          underline="none"
                          target="_blank"
                        >
                          {t("Visage_Help")}
                        </Link>
                        {"  "}
                        {t("website")}
                      </Typography>
                    </div>
                  </FleetCarLegend>
                </Box>
              </Modal>
            </span>
          </Tooltip>
        </div>
      </Header>
      <CarType style={{minHeight: carInformation?.CarMake || carInformation?.CarModel ? "100px" : ""}}>
        {/* <CarImage width={190} height={187} className="big-car" /> */}
        <svg width="190" height="35" /> {/* kludge space filler because height of CarImage svg that is hidden for now was critical for layout */}

        <div className="edit-text">
          {/* <p>{t("2019_Club_Car_Tempo_Lithium-Ion")}</p> */}
          <p>&nbsp;</p> {/* kludge space filler because height of CarImage svg that is hidden for now was critical for layout */}
          {actionZoneAlert && (
            <>
              <p className="max-hole-exceeded">
                This Car is in an alert Action Zone!
              </p>
              <p className="action-zone-alert">
                {t("Action_Zone")}: {actionZoneText}
              </p>
            </>
          )}
          {carInformation?.Car?.MaxHolesExceeded && (
            <p className="max-hole-exceeded">
              This Car is over the maximum holes allowed!
            </p>
          )}
        </div>

        <div className="battery-status">
          <div className="persent">
            {<RenderBatteryIcon car={carInformation?.Car} />}
            {BatteryLevel <= 100 && <p>{BatteryLevel}%</p>}
          </div>
          <div style={{ marginTop: "5px" }}>
            {Connection == connectionType.none ? (
              <>
                <CarNotCommunicatingImage color="red" />
                <span style={{ paddingLeft: "10px" }}>
                  {t("Not_communicating")}
                </span>
              </>
            ) : (
              ""
            )}
          </div>
          <div>
            {siteSettingsData &&
              siteSettingsData?.GuardianCapable &&
              !carInformation?.Car?.AllowedToMove ? (
              <>
                <LockIcon width={18} />
                <span style={{ paddingLeft: "10px" }}>Locked</span>
              </>
            ) : (
              ""
            )}
          </div>
          <div>
            {siteSettingsData &&
              siteSettingsData?.GuardianCapable &&
              !HasMoved &&
              siteSettingsData.GuardianMode !== 1 &&
              carInformation?.Car?.AllowedToMove
              ? ""
              : siteSettingsData &&
                siteSettingsData?.GuardianCapable &&
                !carInformation?.Car?.AllowedToMove
                ? ""
                : !HasMoved && <span>{t("Staged")}</span>}
          </div>

          <div>
            {isCarInUse(carInformation.Car) == true ? (
              <span>{t("In_use")}</span>
            ) : (
              ""
            )}
          </div>
          <div>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {(carInformation?.CarMake || carInformation?.CarModel) ? (carInformation?.CarMake + " " + carInformation?.CarModel) : <span style={{ opacity: 0.5 }}>&nbsp;</span>}
            </span>
          </div>
        </div>
      </CarType>
      <Container>
        <AppBar position="static">
          <Tabs
            value={tabIndex}
            onChange={handleTabsChange}
            variant="scrollable"
            scrollButtons="false"
            aria-label="scrollable prevent tabs example"
          >
            {siteSettingsData &&
              siteSettingsData?.GuardianCapable &&
              siteSettingsData?.GuardianMode === 2 &&
              carInformation?.Car?.AllowedToMove ? (
              <Tab
                icon={<LockIcon></LockIcon>}
                aria-label="phone"
                {...a11yProps(0)}
              />
            ) : siteSettingsData &&
              siteSettingsData?.GuardianCapable &&
              (!carInformation?.Car?.AllowedToMove ||
                siteSettingsData?.GuardianMode === 3) ? (
              <Tab
                icon={<UnLockIcon></UnLockIcon>}
                aria-label="phone"
                {...a11yProps(0)}
              />
            ) : (
              <Tab
                icon={<UnLockIcon></UnLockIcon>}
                aria-label="phone"
                {...a11yProps(0)}
              />
            )}

            <Tab
              icon={renderCarIcon()}
              aria-label="SignalIcon"
              {...a11yProps(1)}
            />
            <Tab
              label={
                carInformation?.Car?.MaxSpeed === 0 ||
                  carInformation?.Car?.MaxSpeed === -1
                  ? t("Default")
                  : isSiteUsingYards()
                    ? carInformation?.Car?.MaxSpeed + "mph"
                    : Math.round(convertMileToKM(carInformation?.Car?.MaxSpeed)) +
                    "kph"
              }
              style={{ textTransform: "capitalize" }}
              aria-label="person"
              className="speed-text"
              {...a11yProps(2)}
            />

            <Tab
              icon={
                <SignalIcon
                  width={"20px"}
                  height={"26.58px"}
                  color={isWifi() ? "#5AADFF" : "#636F7C"}
                />
              }
              aria-label="help"
              {...a11yProps(3)}
            />

            <Tab
              icon={
                <MobileSignalIcon
                  width={"20px"}
                  height={"26.58px"}
                  color={issingle() ? "#5AADFF" : "#636F7C"}
                />
              }
              aria-label="shopping"
              className="last-btn"
              {...a11yProps(4)}
            />
          </Tabs>
        </AppBar>

        {carProductData &&
          Object.keys(carProductData).length > 0 &&
          carProductData.GpsiCarId === carid &&
          (canEnable(carInformation?.Car) || canStage(carInformation?.Car)) ? (
          <TabPanel value={tabIndex} index={0}>
            <TabWrapper className="car-property-tab-wrapper">
              <div className="lock-wrapper">
                {canStage(carInformation?.Car) ? (
                  <div className="fleet-car-wrapper">
                    <label className="stage-car">
                      <div className="fleet-car-wrapper">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={setStagedCarsState.get()}
                              onChange={(e) => handleStageCar(e)}
                              inputProps={{ "aria-label": "controlled" }}
                              icon={<UnCheckIcon width={20} height={20} />}
                              checkedIcon={<CheckIcon width={20} height={20} />}
                            />
                          }
                          label={t("Stage_car")}
                        />
                      </div>
                    </label>

                    <div className="fleet-car-wrapper">
                      <Button
                        variant="outlined"
                        className={stageCarActiveButton ? "active" : "disabled"}
                        onClick={staggingChanges}
                      >
                        {t("Save")}
                      </Button>

                      <Button
                        variant="outlined"
                        className="stage-button"
                        onClick={handleCancelChanges}
                      >
                        {t("Cancel")}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {canEnable(carInformation?.Car) ? (
                  <div className="fleet-car-wrapper for-enable-car">
                    <>
                      <div className="inner-btn">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={EnabledCarsState}
                              onChange={(e) => handleEnableCar(e)}
                              inputProps={{ "aria-label": "controlled" }}
                              icon={<UnCheckIcon width={15} height={15} />}
                              checkedIcon={<CheckIcon width={15} height={15} />}
                            />
                          }
                          label={t("Enable_car")}
                        />
                        <span>
                          <KeyIcon />
                          {carProductData && carProductData?.UnlockCode !== 0
                            ? carProductData?.UnlockCode
                            : ""}
                        </span>
                      </div>
                      <div className="inner-btn">
                        <Button
                          variant="outlined"
                          className={enableCarActiveButton ? "active" : "disabled"}
                          onClick={handleSaveCar}
                        >
                          {t("Save")}
                        </Button>
                        <Button
                          variant="outlined"
                          className="stage-button"
                          onClick={() => {
                            setEnableCarActiveButton(false);
                            setTabIndex(0);
                          }}
                        >
                          {t("Cancel")}
                        </Button>
                      </div>
                    </>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </TabWrapper>
          </TabPanel>
        ) : (
          <></>
        )}

        {!show && (
          <TabPanel value={tabIndex} index={1} >
            <TabWrapper>
              <div className="fleet-car-wrapper">
                <SelectContainer className="select">
                  <FormControl sx={{ m: 1, minWidth: 160, maxWidth: 210 }} size="small">
                    <Select
                      value={carTypeVal}
                      defaultValue={carTypeVal}
                      name="carvalue"
                      onChange={handleCarType}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem
                        style={{ display: "none" }}
                        value="Select car type..."
                      >
                        Select car type...
                      </MenuItem>
                      <MenuItem value={constCartype.normal}>
                        {iconData.FleetCar}
                      </MenuItem>
                      <MenuItem value={constCartype.handicap}>
                        {iconData.SpecialNeedCar}
                      </MenuItem>
                      <MenuItem value={constCartype.marshal}>
                        {iconData.MarshalCar}
                      </MenuItem>
                      <MenuItem value={constCartype.bevcart}>
                        {iconData.BeverageCar}
                      </MenuItem>
                      <MenuItem value={constCartype.outOfService}>
                        {iconData.OutOfService}
                      </MenuItem>
                      {isMemberCar && <MenuItem value={constCartype.member}>
                        {iconData.MemberCar}
                      </MenuItem>}
                      {isMemberCar && <MenuItem value={constCartype.memberSpecial}>
                        {iconData.MemberSpecial}
                      </MenuItem>}
                    </Select>
                  </FormControl>
                </SelectContainer>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={persistCarType}
                      disabled={defaultCartypes.includes(carTypeVal) || isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)}
                      onClick={() => { setCarTypeActiveButton(true); setPersistCarType(!persistCarType) }}
                      value={persistCarType}
                      inputProps={{ "aria-label": "controlled" }}
                      icon={<UnCheckIcon width={20} height={20} />}
                      checkedIcon={<CheckIcon width={20} height={20} />}
                    />
                  }
                  label={t("Persist_Car_Type")}
                />
                <div className="inner-btn">
                  <Button
                    onClick={saveCarType}
                    variant="outlined"
                    className={carTypeActiveButton ? "active" : "disabled"}
                  >
                    {t("Save")}
                  </Button>
                  <Button variant="outlined" onClick={closeModal}>
                    {t("Cancel")}
                  </Button>
                </div>
              </div>
            </TabWrapper>
          </TabPanel>
        )}
        {!show && (
          <TabPanel value={tabIndex} index={2}>
            <TabWrapper>
              <div className="fleet-car-wrapper">
                <SelectContainer className="select">
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <Select
                      value={speedData}
                      disabled={(carType === constCartype?.member && getFeatureSetOption(
                        siteSettingsData?.Features,
                        getFeaturesList().member_cars
                      )) || isUserReadOnly(getUserRole && getUserRole?.Role)}
                      name="carvalue"
                      onChange={handleSpeedChange}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={0 | -1}>{t("Default")}</MenuItem>
                      <MenuItem value={15}>
                        {isSiteUsingYards() ? "15 mph" : "24 kph"}
                      </MenuItem>
                      <MenuItem value={14}>
                        {isSiteUsingYards() ? "14 mph" : "22 kph"}
                      </MenuItem>
                      <MenuItem value={13}>
                        {isSiteUsingYards() ? "13 mph" : "21 kph"}
                      </MenuItem>
                      <MenuItem value={12}>
                        {isSiteUsingYards() ? "12 mph" : "19 kph"}
                      </MenuItem>
                      <MenuItem value={11}>
                        {isSiteUsingYards() ? "11 mph" : "18 kph"}
                      </MenuItem>
                      <MenuItem value={10}>
                        {isSiteUsingYards() ? "10 mph" : "16 kph"}
                      </MenuItem>
                      <MenuItem value={9}>
                        {isSiteUsingYards() ? "9 mph" : "14 kph"}
                      </MenuItem>
                      <MenuItem value={8}>
                        {isSiteUsingYards() ? "8 mph" : "13 kph"}
                      </MenuItem>
                      <MenuItem value={7}>
                        {isSiteUsingYards() ? "7 mph" : "11 kph"}
                      </MenuItem>
                      <MenuItem value={6}>
                        {isSiteUsingYards() ? "6 mph" : "10 kph"}
                      </MenuItem>
                      <MenuItem value={5}>
                        {isSiteUsingYards() ? "5 mph" : "8 kph"}
                      </MenuItem>
                      <MenuItem value={4}>
                        {isSiteUsingYards() ? "4 mph" : "6 kph"}
                      </MenuItem>
                      <MenuItem value={3}>
                        {isSiteUsingYards() ? "3 mph" : "5 kph"}
                      </MenuItem>
                      <MenuItem value={2}>
                        {isSiteUsingYards() ? "2 mph" : "3 kph"}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </SelectContainer>
                <div className="inner-btn">
                  <Button
                    variant="outlined"
                    onClick={saveSpeedData}
                    className={speedDataActiveButton ? "active" : "disabled"}
                  >
                    {t("Save")}
                  </Button>
                  <Button variant="outlined" onClick={closeModal}>
                    {t("Cancel")}
                  </Button>
                </div>
              </div>
            </TabWrapper>
          </TabPanel>
        )}
      </Container>
      {carInformation?.Car?.Course !== 0 && isCarInUse(carInformation?.Car) ? (
        <HoleSpeedWrapper>
          <button className="flag">{renderHoleNumber()}</button>

          <button className="time">
            {PaceStatus == 2 ? (
              <TimeIcon color="yellow" height={25} width={25} />
            ) : PaceStatus == 3 ? (
              <TimeIcon color="red" height={25} width={25} />
            ) : (
              <TimeIcon color="green" height={25} width={25} />
            )}
            {PaceStatus == 2 ? (
              <div style={{ color: "yellow" }}>{pacestring}</div>
            ) : PaceStatus == 3 ? (
              <div style={{ color: "red" }}>{pacestring}</div>
            ) : (
              <div style={{ color: "green" }}>{pacestring}</div>
            )}
          </button>
          <button className="yds">
            <span>
              <span onClick={newDistancenew}>
                {carInformation?.Car?.DistanceUnits === 1
                  ? "yds"
                  : carInformation?.Car?.DistanceUnits === 2
                    ? "mtr"
                    : ""}
              </span>
            </span>
          </button>
        </HoleSpeedWrapper>
      ) : (
        <></>
      )}
      <Players>
        <li>
          <PlayerIcon />
          <li ref={inputelm} style={{ width: "100%" }}>
            {showLoadingField === t("Player_1") ? (
              <ResendIcon className="rotate" />
            ) : (
              <input
                type="text"
                maxLength={50}
                onBlur={() => editableComponent(t("Player_1"))}
                value={playerNameData1.get()}
                placeholder={t("Player_1")}
                onChange={(e) => {
                  playerNameData1.set(e.target.value);
                }}
              />
            )}
          </li>
        </li>

        <li>
          <PlayerIcon />

          <li ref={inputelm} style={{ width: "100%" }}>
            {showLoadingField === t("Player_2") ? (
              <ResendIcon className="rotate" />
            ) : (
              <input
                type="text"
                maxLength={50}
                onBlur={() => editableComponent(t("Player_2"))}
                value={playerNameData2.get()}
                placeholder={t("Player_2")}
                onChange={(e) => {
                  playerNameData2.set(e.target.value);
                }}
              />
            )}
          </li>
        </li>
      </Players>
      {update !== "" ? (
        <SoftwareUpdate onClick={() => setOpenSoftwareUpdate(true)}>
          <DownloadIcon height={17.7} width={18} />
          <div>
            <p>{t("Software_Update")}</p>
            <span>{t("Connect_to_Wi-Fi_to_download")}</span>
          </div>
        </SoftwareUpdate>
      ) : (
        ""
      )}
      <Modal open={openSoftwareUpdate} onClose={() => setOpenSoftwareUpdate(false)}>
        <Box sx={modalStyle}>
          <h5>
            {t("Pending_updates_for_car")} {carnumber}
          </h5>
          <span style={crossButtonStyle} onClick={() => setOpenSoftwareUpdate(false)}>
            <ModalCloseIcon width={14} height={14} color="#fff" />
          </span>
          <hr />
          <ItemWrapper>{updatesList()}</ItemWrapper>
        </Box>
      </Modal>
      <DropDownContainer>
        <p>{t("Max_Number_of_Holes") + ":"}</p>
        {showLoadingField === t("Max_Number_of_Holes") ? (
          <ResendIcon className="rotate" />
        ) : (<FormControl size="small" className="select">
            <Select
              value={holes}
              name="CarSetting"
              onChange={holesChange}
              disabled={!EnableMaxHole}
              IconComponent={ExpandMoreIcon}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={holesConst.select}>{t("Select..")}</MenuItem>
              <MenuItem value={holesConst.useFleetSetting}>{t("Use_fleet_setting")}</MenuItem>
              <MenuItem value={holesConst.nine}>{holesConst.nine}</MenuItem>
              <MenuItem value={holesConst.eighteen}>{holesConst.eighteen}</MenuItem>
              <MenuItem value={holesConst.unlimited}>{t("Unlimited")}</MenuItem>
            </Select>
          </FormControl>)}
      </DropDownContainer>
      <DropDownContainer>
        <p>{t("Show/Hide_Distances") + ":"}</p>
        {showLoadingField === t("Show/Hide_Distances") ? (
          <ResendIcon className="rotate" />
        ) : (<FormControl size="small" className="select">
          <Select
            value={distancesEnabled}
            name="HideShowDistance"
            disabled={(carType === constCartype.member && !memberEnabled) || (isUserReadOnly(getUserRole && getUserRole?.Role)) || (isUserBasic(getUserRole && getUserRole?.Role))}
            onChange={(e) => {
              setDistancesEnabled(e.target.value);
            }}
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={distances.hideDistances}>{t("Hide_distances")}</MenuItem>
            <MenuItem value={distances.showDistances}>{t("Show_Distances")}</MenuItem>
            <MenuItem value={distances.useFleetSetting}>{t("Use_fleet_setting")}</MenuItem>
          </Select>
        </FormControl>)}
      </DropDownContainer>
      <DropDownContainer>
        <p>{t("Speaker_Setting") + ":"}</p>
        {showLoadingField === t("Speaker_Setting") ? (
          <ResendIcon className="rotate" />
        ) : (<FormControl size="small" className="select">
          <Select
            value={speakerSetting}
            disabled={!memberEnabled || (isUserReadOnly(getUserRole && getUserRole?.Role))}
            name="SpeakerVolume"
            onChange={(e) => {
              handleSpeakerVolumeChange(e)
            }}
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={speakerVolume.UseFleetSetting}>{t("Use_fleet_setting")}</MenuItem>
            <MenuItem value={speakerVolume.External}>{t("External")}</MenuItem>
            <MenuItem value={speakerVolume.Internal}>{t("Internal")}</MenuItem>
            <MenuItem value={speakerVolume.ExternalAmp}>{t("External_Amp")}</MenuItem>
          </Select>
        </FormControl>)}
      </DropDownContainer>
      {!isUserBasic(getUserRole && getUserRole?.Role) &&
        !isUserReadOnly(getUserRole && getUserRole?.Role) && (
          <div className="checkbox-wrapper">
            <FormControlLabel
              control={
                <Checkbox
                  onClick={deRegisterCar}
                  value={allowedToMove}
                  inputProps={{ "aria-label": "controlled" }}
                  icon={<UnCheckIcon width={20} height={20} />}
                  checkedIcon={<CheckIcon width={20} height={20} />}
                />
              }
              label={t("Deregister_car")}
            />
          </div>
        )}

      <DetailAccordions
        holeNo={renderHoleNumber()}
        gpsiCarId={carid}
        update={lastUpdate}
        lastupdate={checkLastDate()}
        siteSettingsData={siteSettingsData}
        carNo={carnumber}
        ActionZoneLabel={actionZoneText}
        ActionZoneId={ActionZoneId}
        car={carInformation}
      />
    </CarDetailsWrapper>
  );
});
